import { useMemo } from "react";
import { Navigate, useParams } from "react-router-dom";
import { StoredHotelBookingData } from "src/store/slices/hotels/Hotels";
import { SearchFormInputs } from "../../constants/SearchPage";
import HotelBooking from "./HotelBooking";

export type HotelBookingLoaderData = {
  stored: StoredHotelBookingData;
  searchObject: SearchFormInputs;
};

export default function HotelBookingLoader() {
  const { searchId, hotelKey } = useParams();

  const data = useMemo<HotelBookingLoaderData | null>(() => {
    const searchJson = localStorage.getItem(`${searchId}`);
    const storedJson = localStorage.getItem(`${hotelKey}`);
    if (!searchJson || !storedJson) return null;

    try {
      const parsed: HotelBookingLoaderData = {
        stored: JSON.parse(storedJson),
        searchObject: JSON.parse(searchJson),
      };
      if (!parsed.stored.hotel) return null;
      return parsed;
    } catch {
      return null;
    }
  }, [searchId, hotelKey]);

  if (!data) return <Navigate to="/not-found" replace />;
  return <HotelBooking {...data} />;
}
